/** Stripe customer portal screens the dashboard can open directly. */
export const BILLING_PORTAL_FLOWS = [
    "payment_method_update",
    "subscription_cancel",
] as const;

export type BillingPortalFlow = (typeof BILLING_PORTAL_FLOWS)[number];

export function parseBillingPortalFlow(value: unknown): BillingPortalFlow | null {
    return typeof value === "string" && (BILLING_PORTAL_FLOWS as readonly string[]).includes(value) ? (value as BillingPortalFlow) : null;
}

/**
 * On/off switches for dashboard UI that we want to show or hide without a deploy, such as fake
 * doors that measure interest in a feature before it exists. Flip them by updating the
 * `dashboard_flags` row in mcp_settings, e.g. `{"team_plan_interest": true}`.
 */
export interface DashboardFlags {
    /** "Buying for a team?" row on Plan & billing, linking to the team plan form. */
    teamPlanInterest: boolean;
    /** "Want to share your device with someone else?" line under the device list. */
    deviceShareInterest: boolean;
    /** "Want to use a server we host instead of your own computer?" line where a device is added. */
    hostedServerInterest: boolean;
}

export const DASHBOARD_FLAGS_OFF: DashboardFlags = {
    teamPlanInterest: false,
    deviceShareInterest: false,
    hostedServerInterest: false,
};
